import { Component, EventEmitter, Input, Output } from '@angular/core';

import { IContactNumberField, MultiFieldData } from '@shared/interfaces';

@Component({
  selector: 'app-section-contact-number',
  templateUrl: './section-contact-number.component.html',
  styleUrls: ['./section-contact-number.component.scss'],
})
export class SectionContactNumberComponent {
  @Input() contactNumber: IContactNumberField;
  @Input() value: any; // ✅ receive customer_name value from parent
  @Output() setValue = new EventEmitter<any>();

  onComplexFieldSetClicked(_form: MultiFieldData) {
    this.setValue.emit(_form.value); // ✅ emit only value
  }
}
